module.exports = __webpack_public_path__ + "img/home_banner1.a29f02c2.png";